import { getCookie } from "@one.com/react-common/functions";
import { loadUserDataFromSession } from "store/actions";

const purchase = (data) => async (dispatch) => {
  let res;
  try {
    res = await dispatch(loadUserDataFromSession());
  } catch (e) {
    // Backend/session might be unavailable during tests or edge cases.
    // Proceed with best-effort tracking.
  }

  const userDataFromSession = res?.data;
  const customer = userDataFromSession?.customer ?? {};
  const utmId = getCookie("OneUtmId");

  const hasCustomerInfo = customer && Object.keys(customer).length > 0;
  const hasUtmId = utmId != null && utmId !== "";

  if (hasCustomerInfo || hasUtmId) {
    window.GTM.pushPurchase(data, { customer, utmId });
  } else {
    window.GTM.pushPurchase(data);
  }
};

export default purchase;
